<template>
  <b-modal
    :visible="visible"
    title="Client credentials"
    ok-title="I have stored these credentials"
    ok-only
    no-close-on-backdrop
    no-close-on-esc
    :hide-header-close="true"
    size="lg"
    @ok="$emit('update:visible', false)"
    @hidden="$emit('update:visible', false)"
  >
    <b-alert variant="warning" show>
      <div class="alert-body">
        <feather-icon icon="AlertTriangleIcon" class="mr-50" />
        This secret is shown <strong>once</strong>. Only its hash is stored, so it cannot
        be retrieved again — it can only be regenerated, which invalidates the old one.
      </div>
    </b-alert>

    <b-form-group label="Client ID">
      <b-input-group>
        <b-form-input :value="clientId" readonly />
        <b-input-group-append>
          <b-button variant="outline-primary" @click="copy(clientId)">
            <feather-icon icon="CopyIcon" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group label="Client Secret">
      <b-input-group>
        <b-form-input :value="clientSecret" readonly />
        <b-input-group-append>
          <b-button variant="outline-primary" @click="copy(clientSecret)">
            <feather-icon icon="CopyIcon" />
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <hr class="my-2" />

    <p class="small text-muted mb-50">
      The partner exchanges these for a bearer token, then calls every v2 endpoint with
      that token:
    </p>
    <pre class="bg-light p-1 rounded small mb-0"><code>curl -X POST {{ tokenUrl }} \
  -u '{{ clientId }}:{{ clientSecret }}'</code></pre>
  </b-modal>
</template>

<script>
import {
  BModal,
  BAlert,
  BButton,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BModal,
    BAlert,
    BButton,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: String,
      default: '',
    },
    clientSecret: {
      type: String,
      default: '',
    },
  },
  computed: {
    tokenUrl() {
      const base = String(process.env.VUE_APP_SERVER_URL || '').replace(/\/api\/v1\/?$/, '')
      return `${base}/api/v2/auth/token`
    },
  },
  methods: {
    async copy(value) {
      try {
        await navigator.clipboard.writeText(value)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Copied',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: 'Copied to clipboard',
          },
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: 'Could not copy to clipboard',
          },
        })
      }
    },
  },
}
</script>
